import { REMOVE_ALERT } from './index';

export const hideToast = () => ({
  type: REMOVE_ALERT,
});